import React from "react";
import { EmptyState, LoadingSpinner } from 'components/common';
import { MdErrorOutline } from "react-icons/md";
import PIFForm from "./PIFForm";
import { usePifFromRoute } from "./usePifFromRoute";

const EditPIF = () => {
  const { pif, loading, error } = usePifFromRoute();

  // Nothing is rendered until the PIF is fresh from the server. The form seeds
  // each record exactly once, so handing it a stale snapshot first would stick:
  // the fresh copy arriving afterwards would not re-seed, and Save would write
  // the old content back over whatever the user had already done.
  if (loading) return <LoadingSpinner message="Loading PIF..." />;

  if (error || !pif) {
    return (
      <EmptyState
        icon={MdErrorOutline}
        title="This PIF could not be loaded"
        description={error || 'The PIF no longer exists, or the link points at the wrong record.'}
      />
    );
  }

  const { project, building, adaptation } = pif;

  return (
    <PIFForm
      project={project}
      building={building}
      adaptation={adaptation}
      pif={pif}
      title="Edit"
    />
  );
};

export default EditPIF;
